import React from "react";

import FaceMeshAsyncV2Page from "./FaceMeshAsyncV2Page";

const GLASSES_CONTINUE_URL = "/glasses-3month-29-upsell-v2";

const GLASSES_PROGRESS_STEPS = [
  { threshold: 10, label: "Scanning your face shape and proportions" },
  { threshold: 35, label: "Measuring forehead, cheekbones, and jawline" },
  { threshold: 60, label: "Checking balance points for frame fit" },
  { threshold: 85, label: "Comparing flattering glasses silhouettes" },
  { threshold: 100, label: "Preparing your personalized glasses match" },
];

const FaceMeshGlassesV2Page = () => {
  return (
    <FaceMeshAsyncV2Page
      analyticsPrefix="facemesh_glasses_v2"
      continueUrl={GLASSES_CONTINUE_URL}
      missingImageHelpPath="/facemesh-glasses-v2"
      pagePath="/facemesh-glasses-v2"
      progressSteps={GLASSES_PROGRESS_STEPS}
      heading={
        <>
          For accurate glasses matching,
          <br />
          we analyze your face shape
        </>
      }
      progressTitle="Glasses match progress"
      preparingText="Preparing your glasses analysis..."
      finalizingText="Finalizing your glasses match..."
      documentTitle="AI Glasses Match"
    />
  );
};

export default FaceMeshGlassesV2Page;
